module.exports = __webpack_public_path__ + "static/media/relative-change.6f990c3c.svg";